<template>
  <span>
    <v-input
      :id="inputId"
      block
      suffix="mm"
      type="number"
      :value="value"
      :disabled="disabled"
      :placeholder="$t('common.typehere')"
      :has-error="showValidationError"
      :class="{
        'text-red': matchMode && !isVerified,
        'text-primary': matchMode && isVerified,
      }"
      :primary-border="matchMode ? focused && isVerified : focused"
      :red-border="matchMode && focused && !isVerified"
      :read-only="readOnly || hasDismatchError"
      v-on="$listeners"
      @focus="
        focused = true;
        $emit('focus');
      "
      @blur="
        focused = false;
        $emit('blur');
      "
    />

    <div v-if="showValidationError" class="popup popup--error" :class="{ 'pr-50': matchMode }">
      {{ errorMessage }}
      <a v-if="matchMode" @mousedown.prevent="$emit('errorApproved')" class="popup__approve"></a>
    </div>

    <div v-if="focused && hasDismatchError" class="popup popup--match">
      <a class="link" @mousedown.prevent="$emit('input', matchValue)">Database: {{ matchValue }} mm</a>
    </div>
  </span>
</template>

<script>
import { VInput } from "shared";

export default {
  name: "VPillShapeFormInput",
  components: {
    VInput,
  },
  props: [
    "value",
    "validation",
    "errorMessages",
    "disabled",
    "readOnly",
    "matchValue",
    "errorApproved",
    "mismatchApproved",
    "matchMode",
    "inputId",
  ],
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    errorMessage() {
      return ["between", "notEqual", "biggerThan", "sqrtRule", "lowerThan", "aboveZero"]
        .filter((item) => item in this.validation && !this.validation[item])
        .map((item) => this.errorMessages[item])
        .join("  &  ");
    },
    showValidationError() {
      if (this.matchMode) {
        return this.focused && this.hasValidationError;
      } else {
        return !this.readOnly && this.hasValidationError && this.validation.$dirty;
      }
    },
    valuesDismatch() {
      return !!this.matchValue && +this.value !== +this.matchValue;
    },
    hasDismatchError() {
      return this.matchMode && this.valuesDismatch && !this.mismatchApproved;
    },
    hasValidationError() {
      return this.validation.$invalid && !this.errorApproved;
    },
    isVerified() {
      return this.matchMode && !this.hasDismatchError && !this.hasValidationError;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.popup {
  position: absolute;
  right: 0;
  top: calc(100% + 3px);
  background: $color-white;
  color: $color-medium-grey;
  box-shadow: 0 2px 4px rgba(153, 153, 153, 0.4);
  border-radius: 6px 1px 6px 6px;
  font-size: 13px;
  white-space: nowrap;
  line-height: 40px;
  z-index: 10;

  & + & {
    top: calc(100% + 47px);
  }

  &--error {
    padding: 0 15px 0 50px;
    background: $color-white url("~@/assets/icons/icon-error.svg") 16px center no-repeat;
    color: $color-red;
  }

  &--match {
    padding: 0 48px 0 16px;
  }

  &__approve {
    position: absolute;
    right: 16px;
    top: 8px;
    background: url("~@/assets/icons/icon-approve.svg");
    width: 24px;
    height: 24px;
    cursor: pointer;
    text-indent: -99999px;
  }

  .link {
    &:hover {
      text-decoration: underline;
    }
  }
}

::v-deep .input {
  background: #fdfdfd;
  height: 40px;
  width: 112px !important;
  &:focus {
    border-width: 2px;
    &.input-with-suffix {
      padding-right: 39px;
    }
  }
}
</style>
